import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { cloneElement, createRef, Fragment, memo, } from 'react';
import { Popover, PopoverContent, } from '../Popover';
import { sizes } from './constants';
const defaultProps = {
    contentRef: createRef(),
    open: false,
    size: sizes.medium,
    targetRef: createRef(),
    toggleDropdown: () => { },
    zIndex: 999999,
};
const handleKeyPress = (func) => ({ key = '', }) => ((key === 'Enter'
    || key === 'Space')
    ? func
    : () => { });
const DropdownButtonStateless = ({ button, children, contentRef = defaultProps.contentRef, open = defaultProps.open, size = defaultProps.size, targetRef = defaultProps.targetRef, toggleDropdown = defaultProps.toggleDropdown, zIndex = defaultProps.zIndex, }) => (_jsxs(Fragment, { children: [_jsx("div", Object.assign({ css: css `
        display: inline-block;
      `, onClick: toggleDropdown, onKeyPress: handleKeyPress(toggleDropdown), ref: targetRef, role: "button", tabIndex: 0 }, { children: cloneElement(button, {
                iconType: 'arrow-down',
            }) })), _jsx(Popover, Object.assign({ open: open, ref: contentRef, zIndex: zIndex }, { children: _jsx(PopoverContent, { children: children }) }))] }));
const MemoizedDropdownButtonStateless = memo(DropdownButtonStateless);
export { MemoizedDropdownButtonStateless as DropdownButtonStateless };
// MC-1068 Temporary hack for Storybook.
export default DropdownButtonStateless;
